import Room from '@/api/Room'

export default {
  state: {
    code: null,
    room: null,
    socketHost: null,
    isFetching: null,
    error: null
  },
  getters: {
    roomCode: state => state.code,
    roomID: state => state.room,
    roomError: state => state.error
  },
  mutations: {
    ROOM_IS_FETCHING(state, value = true) {
      state.isFetching = value
      state.error = null
    },
    ROOM_SET_CODE(state, roomCode) {
      state.code = roomCode
    },
    ROOM_SET_ROOM(state, roomID) {
      state.room = roomID
    },
    ROOM_SET_HOST(state, host) {
      state.socketHost = host
    },
    ROOM_GET_CONNECTION_DATA_SUCCESS(state, roomData) {
      state.isFetching = false
      state.error = null
      state.code = roomData.code
      state.room = roomData.room
      state.socketHost = roomData.socketHost
    },
    ROOM_ERROR(state, error) {
      state.isFetching = false
      state.error = error
    }
  },
  actions: {
    ROOM_GET_CONNECTION_DATA({ commit }, { cid, tourSlug }) {
      return new Promise((resolve, reject) => {
        commit('ROOM_IS_FETCHING')
        Room.getConnectionData(cid, tourSlug)
          .then(res => {
            commit('ROOM_GET_CONNECTION_DATA_SUCCESS', res)
            resolve(res)
          })
          .catch(error => {
            commit('ROOM_ERROR', error && error.response && error.response.data ? error.response.data.error : null)
            reject()
          })
      })
    }
  }
}
